export const LANGUAGE_DEFAULT = 'pl';
export const ADULTS_DEFAULT = 2;
export const CHILDREN_DEFAULT = null;